var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _path11, _path12, _path13, _path14, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path15, _path16, _path17, _path18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError504(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M489,143a5,5,0,0,0,4.91-4.37,10.37,10.37,0,0,0,.06-1.12,9.7,9.7,0,0,0-9.7-9.7l-.65,0a10.3,10.3,0,0,0-20.57.87q0,.39,0,.75a10.3,10.3,0,0,0-15.29,8.26.49.49,0,0,0,0,.12,4.91,4.91,0,0,0,4.92,5.17Z",
    fill: "#e1e6ff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.87,68c9.83,0,10.47-14.8.66-15.37-.32,0-.64,0-1,0a16.23,16.23,0,0,0-5.05.8,17,17,0,0,0-33.59.53A15.68,15.68,0,0,0,371,53c-8.5,2.33-6.54,15,2.28,15Z",
    fill: "#e1e6ff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.15,39c12,0,12.74-18,.8-18.69-.4,0-.82,0-1.23,0a20.14,20.14,0,0,0-6.15,1,20.66,20.66,0,0,0-40.86.66,18.85,18.85,0,0,0-8.22-1.87,19.13,19.13,0,0,0-4.57.56C204.27,23.23,206.34,39,217.31,39Z",
    fill: "#e1e6ff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.21,60.75S317.15,44.08,322.71,73s-28.93,29.17-28.93,29.17Z",
    fill: "#e3e7fe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.21,60.75S317.15,44.08,322.71,73s-28.93,29.17-28.93,29.17Z",
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M323.6,76s11.24-2,15.69-2,5.35.23,6.24,5.57,2,14.49,9.8,14.49H402",
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.57,
    cy: 82.58,
    rx: 15.99,
    ry: 28.66,
    transform: "translate(-10.54 57.1) rotate(-11.14)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.57,
    cy: 82.58,
    rx: 15.99,
    ry: 28.66,
    transform: "translate(-10.54 57.1) rotate(-11.14)",
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.43,
    cy: 84.19,
    rx: 12.83,
    ry: 27.35,
    transform: "translate(-10.95 55.47) rotate(-11.08)",
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.43,
    cy: 84.19,
    rx: 12.83,
    ry: 27.35,
    transform: "translate(-10.95 55.47) rotate(-11.08)",
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278,
    cy: 75.03,
    rx: 3,
    ry: 4,
    fill: "#6576ff"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282,
    cy: 94.03,
    rx: 3,
    ry: 4,
    fill: "#6576ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215,111H197.4a22,22,0,0,1-22-22h0a22,22,0,0,1,22-22h16.23Z",
    fill: "#e3e7fe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215,111H197.4a22,22,0,0,1-22-22h0a22,22,0,0,1,22-22h16.23Z",
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216,99h30.13A2.87,2.87,0,0,1,249,101.9v1.25a2.87,2.87,0,0,1-2.87,2.87H216a0,0,0,0,1,0,0V99A0,0,0,0,1,216,99Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216,99h30.13A2.87,2.87,0,0,1,249,101.9v1.25a2.87,2.87,0,0,1-2.87,2.87H216a0,0,0,0,1,0,0V99A0,0,0,0,1,216,99Z",
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216,70h30.13A2.87,2.87,0,0,1,249,72.9v1.25A2.87,2.87,0,0,1,246.13,77H216a0,0,0,0,1,0,0V70A0,0,0,0,1,216,70Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216,70h30.13A2.87,2.87,0,0,1,249,72.9v1.25A2.87,2.87,0,0,1,246.13,77H216a0,0,0,0,1,0,0V70A0,0,0,0,1,216,70Z",
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95,51.25s31.73-4.25,34,2.31,2.49,9.57,1.42,22.3,9.79,13,15.83,12.85,35.58,0,35.58,0",
    fill: "none",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 61.03,
    width: 12,
    height: 55,
    rx: 5.17,
    ry: 5.17,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 61.03,
    width: 12,
    height: 55,
    rx: 5.17,
    ry: 5.17,
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.42,260H303.91A147.92,147.92,0,0,0,305,230.51q-2.06-37.83-17.32-56.94t-42.13-17.65q-26.86,1.47-40,22.11t-11.05,58.48A158.89,158.89,0,0,0,197.42,260Z",
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.8,260h52.28a156.21,156.21,0,0,0,.6-28q-1.59-29.44-9-42.3t-22-12.06q-14.62.8-20.55,14.48T221.8,235A168.82,168.82,0,0,0,224.8,260Z",
    fill: "#eff1ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.8,260h52.28a156.21,156.21,0,0,0,.6-28q-1.59-29.44-9-42.3t-22-12.06q-14.62.8-20.55,14.48T221.8,235A168.82,168.82,0,0,0,224.8,260Z",
    fill: "none",
    stroke: "#6576ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54,249.34A16.28,16.28,0,0,1,117,253c-9.63-1-15.71-14-15.71-14a2.74,2.74,0,0,0-2.81-1.45l-26.72,4.9a1.87,1.87,0,0,0-1.51,2.3l4.65,13.5A3.42,3.42,0,0,0,77.7,260h84.37a3.27,3.27,0,0,0,2.78-1.85s5-11.83,5.9-20.11q2.13-19.66-9.91-33.15a45.39,45.39,0,0,0-29.9-15.42c-7-.75-16.49,1.25-16.49,1.25a1.29,1.29,0,0,1-1.65-1.57l2.66-17a2.13,2.13,0,0,1,2.3-1.76l48.6,5.26a2,2,0,0,0,2.2-1.77L171.37,148a2,2,0,0,0-1.77-2.2l-79.1-8.57A2.1,2.1,0,0,0,88.22,139L77.51,213a2.33,2.33,0,0,0,1.65,2.5l23.75,6.42a5.09,5.09,0,0,0,3.6-.59s6.78-4.48,12.67-3.84q9.22,1,13.26,6.92a18.46,18.46,0,0,1,3.29,12.74Q134.89,245,129.54,249.34Z",
    fill: "#6576ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 289.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 288.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 281.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 295.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 289.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 290.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 272.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 278.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 278.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 278.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 288.03,
    width: 22,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#c4cefe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M448.49,260a1,1,0,0,1-1,1H69a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H447.47a1,1,0,0,1,1,1Z",
    fill: "#6576ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.81,260a1,1,0,0,1-.88,1H33.69a1,1,0,0,1-.88-1h0a1,1,0,0,1,.88-1H55.93a1,1,0,0,1,.88,1Z",
    fill: "#6576ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M477.12,260a.94.94,0,0,1-.88,1H460a1,1,0,0,1-.89-1h0a1,1,0,0,1,.89-1h16.23a.94.94,0,0,1,.88,1Z",
    fill: "#6576ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.19,112c8.49,0,9.15-12.8.67-13.37-.32,0-.65,0-1,0a14.22,14.22,0,0,0-4.4.69,14.78,14.78,0,0,0-29.24.46,13.6,13.6,0,0,0-5.88-1.33,13.44,13.44,0,0,0-3.61.49c-7.41,2-5.69,13.09,2,13.09Z",
    fill: "#e1e6ff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M420.36,260c1.1,0,2-.2,1.92-.44s.79-.62,1.87-.83l13.39-2.69a2,2,0,0,0,1.57-2.36l-5.64-28.05a2,2,0,0,0-2.35-1.56l-13.4,2.69a2,2,0,0,1-2.35-1.57l-17.06-84.88a2,2,0,0,0-2.35-1.57L355.26,147a4.07,4.07,0,0,0-2.69,2.25L312.51,251.53a7.87,7.87,0,0,0-.34,3.82l.55,2.72a2.55,2.55,0,0,0,2.39,2Zm-52-71.32c.38-1,.86-1,1.08.08l8.89,44.26a2,2,0,0,1-1.56,2.35l-25.39,5.1c-1.08.22-1.65-.45-1.28-1.48Z",
    fill: "#6576ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "435.13 167.88 437.97 163.94 440.81 160 442.8 164.43 444.8 168.85 439.96 168.37 435.13 167.88",
    fill: "#dae0f7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.64 49.82 176.1 44.17 179.56 38.53 182.72 44.35 185.88 50.17 179.26 50 172.64 49.82",
    fill: "#dae0f7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.82 18.56 73.16 16.08 69.49 13.6 73.47 11.67 77.45 9.73 77.14 14.15 76.82 18.56",
    fill: "#dae0f7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.22 108.43 373.51 109.63 369.81 110.82 370.63 107.02 371.44 103.21 374.33 105.82 377.22 108.43",
    fill: "#dae0f7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.2 49.03 470.92 50.03 465.64 50.03 468.24 44.65 470.84 40.06 473.52 44.6 476.2 49.03",
    fill: "#dae0f7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.9 154.9 294.17 152.54 289.45 150.19 293.85 147.28 298.25 144.36 298.57 149.63 298.9 154.9",
    fill: "#dae0f7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.45 167.44 44.94 166.19 42.44 164.94 44.77 163.4 47.1 161.85 47.28 164.64 47.45 167.44",
    fill: "#dae0f7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.21 83.19 112.46 82.7 109.7 82.21 111.51 80.07 113.31 77.93 114.26 80.56 115.21 83.19",
    fill: "#dae0f7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError504);
export default __webpack_public_path__ + "static/media/error-504.8dee1d0c3799fb45dba1305a6f11bd1a.svg";
export { ForwardRef as ReactComponent };